import { CompanyShort, ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../../utils/request';
import { BaseNetworkActionHelper } from '../base.network.action.helper';
import { PopUpRenderData } from '../../../../networkPopUps/types';
import { translateFn } from '../../../../../utils/translator.helper';

export class InstallAgentActionHelper extends BaseNetworkActionHelper {
  public async processAction(selectedTargets: Array<ProtectedEntity>): Promise<PopUpRenderData> {
    const errorResponse: PopUpRenderData = {
      isError: true,
      errorData: {
        title: translateFn('No relay found in your network'),
        errorMessages: [
          translateFn('You need at least one relay to remotely install the security agent on other systems.'),
          translateFn(
            'Create a custom installation package with the Relay role and install it manually on the desired endpoint.'
          ),
        ],
        buttonText: translateFn('OK'),
      },
    };

    const validResponse: PopUpRenderData = {
      isError: false,
    };

    if (!Application.Main.product.isCloud()) {
      return validResponse;
    }

    // the action can run with targets from only 1 company
    const targetsCompany = this.getCompanyOfSelectedTargets(selectedTargets);

    try {
      const hasSuperAgents: boolean = await ConsoleRequest.createRequest<boolean>({
        dataProviderType: DataProviderType.CORE,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'ProtectedEntities',
        method: 'hasSuperAgents',
        payload: {
          companyId: targetsCompany.id,
        },
      });

      return hasSuperAgents ? validResponse : errorResponse;
    } catch (exception) {
      return errorResponse;
    }
  }

  private getCompanyOfSelectedTargets(selectedTargets: Array<ProtectedEntity>): CompanyShort {
    if (selectedTargets[0].type === Constants.Companies.TYPE_COMPANY || !selectedTargets[0].company) {
      return {
        id: selectedTargets[0]._id,
        name: selectedTargets[0].name,
      };
    }

    return selectedTargets[0].company;
  }
}
